import constants from '../globalization';
import { TimeConstants } from '../constants';
import { SourceTypes, PreAuthEnum } from '../enums';
// import moment from 'moment';
import { AsYouType } from 'libphonenumber-js';
import UTIL from 'mroads-js-utils';
// import { dispatchFBNetworkLogs } from "../store";
// import EventEmitter from './event-emitter';

import paidIcon from '../assets/images/Fireboard/paid.png';
import unpaidIcon from '../assets/images/Fireboard/unpaid.png';
import preauthIcon from '../assets/images/Fireboard/finances.png';
import preAuthPoundIcon from '../assets/images/Fireboard/pound_red.png';
import partialPaidPreAuthDollarIcon from "../assets/images/Fireboard/auth_dollar.png";
import partialPaidIcon from "../assets/images/Fireboard/partialPaid.png";
import partialPaidPreAuthPoundIcon from "../assets/images/Fireboard/auth_pound.png";
import posIcon from "../assets/images/Fireboard/POS.png";
import kioskIcon from "../assets/images/Fireboard/kiosk.png";
import curbSideIcon from "../assets/images/Fireboard/curbside.png";
import onlineIcon from "../assets/images/Fireboard/online.png";
import deliveryIcon from "../assets/images/Fireboard/delivery1.png";
import walkupIcon from "../assets/images/Fireboard/walkup.png";
import textToPayIcon from "../assets/images/Fireboard/callin.png";
import scanToPayIcon from "../assets/images/Fireboard/payNow.png";
import marketOrderOnline from "../assets/images/Fireboard/marketplaceOnline.png";
import marketOrderDelivery from "../assets/images/Fireboard/marketplaceDelivery.png";
import callCenterIcon from "../assets/images/Fireboard/callCenterIcon.png";
import tableIcon from "../assets/images/Fireboard/tableicon.png";
import tabIcon from "../assets/images/Fireboard/tabicon.png";
import cateringIcon from "../assets/images/Fireboard/cateringMarketPlace.png";
import cateringDeliveryIcon from "../assets/images/Fireboard/cateringDeliveryMarketPlace.png";

const TEXT_TO_PAY_ORDER_TYPE = 8;

export default class FireboardUtils {
  static displayTime = (closeDate, time) => {
    let displayValue;
    const sentTime = new Date(time).getTime() / 1000;
    let closedTime;
    if (closeDate !== null) {
      closedTime = new Date(closeDate).getTime() / 1000;
    } else {
      // currentTime = Date.now() / 1000;
      closedTime = new Date(time).getTime() / 1000;
    }
    const timeElapsed = parseInt((closedTime - sentTime) / 60);
    if (timeElapsed < 120) {
      displayValue = `${timeElapsed}m`;
    } else {
      displayValue = '2h+';
    }
    return displayValue;
  };

  static getTimeInHrsMins = time => {
    var convertTime = time && time.includes('Z');
    let date;
    if (convertTime)
      date = new Date(time);
    else
      date = new Date(time + 'Z');
    const hours = date.getHours();
    const session = hours >= 12 ? 'PM' : 'AM';

    let hrs = hours > 12 ? hours - 12 : hours;
    hrs = hrs === 0 ? 12 : hrs; // adding condition to handle 12 AM
    hrs = hrs < 10 ? `0${hrs}` : hrs;
    const mins = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    return !isNaN(hrs) && !isNaN(mins) ? `${hrs}:${mins} ${session}` : '--';
  };

  static getTimeForPickup = time => {
    var convertTime = time && time.includes('Z');
    let date;
    if (convertTime)
      date = new Date(time);
    else
      date = new Date(time + 'Z');
    let hours = date.getHours();
    hours = hours < 10 ? `0${hours}` : hours;
    const mins = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    return !isNaN(hours) && !isNaN(mins) ? `${hours}:${mins}` : '';
  }

  static getUTCTimeInHrsMins = time => {
    const splittedTime = time.split('T');
    const splitValues = splittedTime[1].split(':');
    const hours = +splitValues[0];
    const session = hours >= 12 ? 'pm' : 'am';
    let hrs = hours > 12 ? hours - 12 : hours;
    hrs = hrs === 0 ? 12 : hrs; // adding condition to handle 12 AM
    hrs = hrs < 10 ? `0${hrs}` : hrs;
    const mins = +splitValues[1] < 10 ? `0${+splitValues[1]}` : +splitValues[1];
    return `${hrs}:${mins} ${session}`;
  };

  static getOrderNameFromOrderId = order => {
    let retVal = {};
    const { unpaidAmount, tickets } = order;
    switch (order.orderStatusId) {
      case 0: {
        retVal = {
          status: order.sourceType !== 0
            ? constants.orderPending.toUpperCase()
            : (unpaidAmount > 0 && tickets && tickets.length > 0)
              ? constants.orderPending.toUpperCase()
              : constants.orderInProgress.toUpperCase(),
          color: 'orange',
        };
        break;
      }
      case 1: {
        retVal = {
          status: constants.orderInProgress.toUpperCase(),
          color: 'orange',
        };
        break;
      }
      case 5: {
        const [order0] = order?.orders || [];
        const { pickUpStatus } = order0 || {};
        retVal = {
          status: pickUpStatus === 5
            ? constants.pickedUp.toUpperCase()
            : pickUpStatus === 3
              ? constants.seeCounter.toUpperCase()
              : constants.orderComplete.toUpperCase(),
          color: 'green',
        };
        break;
      }
      case 8: {
        retVal = {
          status: constants.cancelOrderText.toUpperCase(),
          color: 'red',
        };
        break;
      }
      case 9:
        retVal = {
          status: constants.orderError.toUpperCase(),
          color: 'red',
        };
        break;
      case 10:
        retVal = {
          status: constants.orderAbandoned.toUpperCase(),
          color: 'red',
        };
        break;
      default:
        console.info('unhandled orderId', order.orderStatusId);
    }
    return retVal;
  };

  static getDueTime = (item, prepWindow) => {
    if (item.sourceType === SourceTypes.CurbSide || item.sourceType === SourceTypes.WalkUp) {
      const orderDate = item.orderDate;
      const currentTime = Date.now();
      return FireboardUtils.displayTime(currentTime, orderDate);
    }
    const currentTime = Date.now();
    let startTime = Date.now();
    const pickupTime = new Date(item.pickupDate).getTime();
    startTime = pickupTime - prepWindow * TimeConstants.MINUTE;
    if (item.checkedIn) {
      const checkInTime = new Date(item.checkInDate).getTime();
      if (pickupTime - checkInTime > prepWindow * TimeConstants.MINUTE) {
        // Early check-in
        startTime = checkInTime;
      }
    }
    if (startTime < currentTime) {
      return FireboardUtils.displayTime(currentTime, startTime);
    }
    return '- -';
  };

  static getCheckInTime = item => {
    if (item.checkInDate) {
      return FireboardUtils.getTimeInHrsMins(item.checkInDate);
    }
    return '- -';
  };

  static getElapsedTime = (check) => {
    const currentTime = new Date().getTime();
    const dueTime = check.pickupDate || check.orderDate || check.openDate;
    var convertTime = dueTime && dueTime.includes('Z');
    let date;
    if (convertTime)
      date = new Date(dueTime);
    else
      date = new Date(dueTime + 'Z');
    const orderTime = new Date(date).getTime();
    return currentTime - orderTime;
  };

  static getButtonStatus = obj => {
    let isDisabled = false;
    Object.keys(obj).forEach(o => {
      if (!obj[o]()) isDisabled = true;
    });
    return isDisabled;
  };

  static getNotificationSourceType = type => {
    // eslint-disable-next-line default-case
    switch (type) {
      case 0:
        return constants.orderType_POS;
      case 1:
        return constants.kioskMode;
      case 5:
        return constants.curbSideOrder;
      case 6:
        return constants.onlineOrder;
      case 7:
        return constants.walkUpMode;
      case 8:
        return constants.orderType_textToPay;
      case 9:
        return constants.orderType_scanToPay;
    }
  };

  static convertedDate = (selectedDate) => {
    var date = new Date(selectedDate);
    if (selectedDate && typeof selectedDate === 'string') {
      if (selectedDate.includes('Z'))
        date = new Date(selectedDate);
      else
        date = new Date(selectedDate + 'Z');
    }
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), month, day].join("-");
  }

  static getPreAuthAvailability = (table: Object) => {
    const preAuthAvailability = [];
    if (table.checks && table.checks.length > 0) {
      for (let checksLen = 0; checksLen < table.checks.length; checksLen++) {
        const preAuthTickets =
          table.checks[checksLen].tickets &&
          table.checks[checksLen].tickets.filter(
            eachTicket => eachTicket.ticketTypeId === PreAuthEnum.TICKET_TYPE_ID &&
              eachTicket.ticketAuthStatusId === PreAuthEnum.TICKET_AUTH_STATUS_ID &&
              eachTicket.ticketStatusId === PreAuthEnum.TICKET_STATUS_ID &&
              eachTicket.preAuth === PreAuthEnum.PREAUTH,
          );
        if (preAuthTickets && preAuthTickets.length > 0) {
          for (
            let preAuthTicketsLen = 0;
            preAuthTicketsLen < preAuthTickets.length;
            preAuthTicketsLen++
          ) {
            preAuthAvailability.push(preAuthTickets[preAuthTicketsLen]);
          }
        }
      }
    }
    return preAuthAvailability;
  };

  static parseStationInfo = (stations, storeInfo) =>
    // eslint-disable-next-line implicit-arrow-linebreak
    stations
      .map(station => {
        const currentStation = FireboardUtils.getStationById(station.stationId, storeInfo);
        if (
          station.checks &&
          station.checks[0]?.mergedStationIds &&
          Array.isArray(station.checks[0]?.mergedStationIds) &&
          station.checks[0].mergedStationIds.length > 0
        ) {
          let numOfChairs = 0;
          const mergedIds = station.checks[0].mergedStationIds;
          mergedIds.forEach(ids => {
            const mergedStation = FireboardUtils.getStationById(ids, storeInfo);
            numOfChairs +=
              mergedStation && mergedStation.numberOfSeats ? mergedStation.numberOfSeats : 2;
          });
          numOfChairs +=
            currentStation && currentStation.numberOfSeats ? currentStation.numberOfSeats : 2;
          return {
            table: station.stationName || '',
            numOfChairs,
            ...station,
          };
        }
        return {
          table: station.stationName || '',
          numOfChairs:
            currentStation && currentStation.numberOfSeats ? currentStation.numberOfSeats : 2,
          ...station,
        };
      })
      .sort(FireboardUtils.sortFunction);

  static getStationById = (stationId, storeInfo) => {
    return storeInfo.data?.stations?.find(s => s.id === stationId);
  };

  static sortFunction = (a, b) => {
    if (!(a.stationName && b.stationName)) {
      return 0;
    }
    if (!isNaN(a.stationName) && !isNaN(b.stationName)) {
      return a.stationName - b.stationName;
    }
    const tab1 = a.stationName?.toLowerCase();
    const tab2 = b.stationName?.toLowerCase();
    if (tab1 < tab2) {
      return -1;
    }
    if (tab1 > tab2) {
      return 1;
    }
    return 0;
  };

  static unFormatToUKPhone(text) {
    return text.replace(/\D/g, '').substring(0, 15);
  }

  static formattedPhoneNumber(phoneNumber, iso2) {
    if (phoneNumber && iso2) {
      return new AsYouType(iso2).input(phoneNumber);
    }
    return phoneNumber;
  }

  static inputFormattedPhnNum(phoneNumber, iso2) {
    if (iso2 === 'us') {
      return UTIL.formatToPhone(phoneNumber);
    } else if (iso2 === 'gb') {
      return FireboardUtils.unFormatToUKPhone(phoneNumber);
    } else {
      return UTIL.unFormatToPhone(phoneNumber);
    }
  }

  static inputUnFormattedPhnNum(phoneNumber, iso2) {
    if (iso2 === 'us') {
      return UTIL.unFormatToPhone(phoneNumber);
    } else if (iso2 === 'gb') {
      return FireboardUtils.unFormatToUKPhone(phoneNumber);
    } else {
      return UTIL.unFormatToPhone(phoneNumber);
    }
  }

  static addNetworkLogs = resp => {
    // if (resp) {
    //   const { config, request, status, responseTime } = resp || {};
    //   const { data } = config || {};
    //   const { responseURL, response } = request || {};
    //   const apiStatus = status === 200 ? 'SUCCESS' : 'FAILURE';
    //   dispatchFBNetworkLogs({
    //     responseURL,
    //     payload: data,
    //     response,
    //     status: apiStatus,
    //   });
    //   if (window.ReactNativeWebView) {
    //     const logMessage = {
    //       url: responseURL,
    //       payload: data,
    //       response: response,
    //       status: status,
    //       timestamp: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
    //       duration: responseTime,
    //     };
    //     EventEmitter.addLogs(
    //       'networkLogs',
    //       apiStatus,
    //       JSON.stringify(logMessage)
    //     );
    //   }
    // }
  };

  static preparePaymentInput = (
    checks: Array<any>,
    taxRate: number,
    items: Array<any>,
    seats: Array<any>,
    isLastSeat: Boolean,
    tableNumber: number,
    currency: string = '$',
  ) => {
    let subTotalAmount = 0;
    let taxAmount = 0;
    let unpaidAmount = 0;
    let paidAmount = 0;
    let totalTotalAmount = 0;
    let checkTotalAmount = 0;
    let taxBreakUp = {};

    checks.forEach(check => {
      unpaidAmount += check.unpaidAmount;
      paidAmount += check.paidAmount;
      totalTotalAmount += check.totalAmount;
    });
    checkTotalAmount = totalTotalAmount;
    const unpaidItems = items.filter(item => !item.paid);
    const discount = unpaidItems.reduce(
      (total, item) => total + (item.discount ? -1 * item.price : 0),
      0,
    );
    const serviceChargeAmount = unpaidItems.reduce(
      (total, item) => total + (item.serviceCharge ? item.price : 0),
      0,
    );
    subTotalAmount = UTIL.round(
      unpaidItems.reduce((total, item) => total + (!item.serviceCharge ? item.price : 0), 0),
    );

    if (currency === '£') {
      const newSubTotalAmount = UTIL.round(subTotalAmount / (1 + taxRate));
      taxAmount = UTIL.round(newSubTotalAmount * taxRate);
      totalTotalAmount = subTotalAmount;
      subTotalAmount = newSubTotalAmount;

      unpaidItems.forEach(item => {
        if (taxBreakUp[item.taxRate]) {
          const tempObj = taxBreakUp[item.taxRate];
          const total = !item.serviceCharge ? item.price : 0;
          taxBreakUp[item.taxRate] = {
            'totalAmount': tempObj.totalAmount + total,
            'taxAmount': tempObj.taxAmount + item.taxAmount,
            'subTotalAmount': tempObj.subTotalAmount + (total - item.taxAmount),
          };
        } else if (item.taxRate >= 0) {
          const total = !item.serviceCharge ? item.price : 0;
          taxBreakUp[item.taxRate] = {
            'totalAmount': total,
            'taxAmount': item.taxAmount,
            'subTotalAmount': total - item.taxAmount,
          };
        }
      });
    } else {
      taxAmount = UTIL.round(subTotalAmount * taxRate);
    }

    const totalAmount = subTotalAmount + taxAmount;
    if (
      totalAmount > unpaidAmount ||
      isLastSeat ||
      (seats.length === 0 && subTotalAmount === 0 && unpaidAmount > 0)
    ) {
      subTotalAmount = UTIL.round(unpaidAmount / (1 + taxRate));
      taxAmount = UTIL.round(unpaidAmount - subTotalAmount);
    }

    const paymentInput = {
      taxAmount,
      unpaidAmount,
      taxRate,
      subTotalAmount,
      serviceChargeAmount,
      items,
      seats,
      paidAmount,
      totalTotalAmount,
      discount,
      cashToBeCollected: 0,
      charity: 0,
      cashPaySeats: [],
      checkNumber: checks[0].number,
      tableNumber,
      taxBreakUp,
      checkTotalAmount,
    };
    return paymentInput;
  };

  static getDeliverTo = (check) => {
    const { sourceType } = check || {};
    const order = check.orders && check.orders.length > 0 && check.orders[0];
    const vehicleInfo = order?.vehicleInfo || null;
    const checkInNote = check?.checkInNote || null;
    const checkName = check?.name || null;
    switch (sourceType) {
      case 0: // POS, DEFAULT
        let posName;
        if (checkInNote)
          posName = posName ? `${posName}\n${checkInNote}` : checkInNote;
        if (vehicleInfo)
          posName = posName ? `${posName}\n${vehicleInfo}` : vehicleInfo;
        if (checkName && checkName !== checkInNote)
          posName = posName ? `${posName}\n${checkName}` : checkName;

        if (check.tab) {
          return posName ? posName : "- -";
        } else {
          if (check.stationNumber && check.name) return `${check.stationNumber}\n${check.name}`;
          else if (check.stationNumber) return check.stationNumber;
          else if (check.name) return check.name;
          else return "- -";
        }

      case 1: // KIOSK
      case 5: // CURBSIDE
      case 6: // ONLINE
      case 7: // WALKUP
      case 8: // TEXTTOPAY
      case 9: // SCANTOPAY
        let name;
        if (checkInNote)
          name = name ? `${name}\n${checkInNote}` : checkInNote;
        if (vehicleInfo)
          name = name ? `${name}\n${vehicleInfo}` : vehicleInfo;
        if (checkName && checkName !== checkInNote)
          name = name ? `${name}\n${checkName}` : checkName;
        return name || "- -";

      default:
        let defaultName;
        if (checkInNote)
          defaultName = defaultName ? `${defaultName}\n${checkInNote}` : checkInNote;
        if (vehicleInfo)
          defaultName = defaultName ? `${defaultName}\n${vehicleInfo}` : vehicleInfo;
        if (checkName && checkName !== checkInNote)
          defaultName = defaultName ? `${defaultName}\n${checkName}` : checkName;

        if (check.sourceType === 0) {
          return defaultName || check.stationNumber || "- -";
        }
        return defaultName || "- -";
    }
  };

  static isTextTPay = sourceType => {
    if (sourceType === TEXT_TO_PAY_ORDER_TYPE)
      return true;
    return false;
  };

  static getGuestName = check => {
    const { orders } = check || {};
    if (orders && orders.length) {
      return orders[0].checkInNote;
    }
    return '';
  };

  static getPhoneNumber = check => {
    const { orders } = check || {};
    if (orders && orders.length) {
      return orders[0].phoneNumber;
    }
    return '';
  };

  static getPickupDate = check => {
    const { orders } = check || {};
    if (orders && orders.length) {
      return orders[0].pickupDate;
    }
    return '';
  };

  static getOrderTypeFromSourceType = type => {
    switch (type) {
      case 5:
        return constants.curbSideOrder;
      case 8:
        return constants.textToPayMode;
      case 1:
        return constants.kioskMode;
      case 9:
        return constants.orderType_scanToPay;
      case 0:
        return constants.orderType_POS;
      case 6:
        return constants.onlineOrder;
      case 7:
        return constants.walkUpMode;
      default:
        return '';
    }
  };

  static getPaidStatusIcon = (check, currency = '$') => {
    let paidImg, preAuthImg;
    const { tickets } = check || {};
    if (Array.isArray(tickets) && tickets.length > 0) {
      for (let ticketIdx = 0, ticketLen = tickets.length; ticketIdx < ticketLen; ticketIdx++) {
        const { ticketStatusId, preAuth } = tickets[ticketIdx] || {};
        if (ticketStatusId === 0 && preAuth && check.unpaidAmount !== 0 && check.paidAmount > 0) {
          preAuthImg = currency === '£' ? partialPaidPreAuthPoundIcon : partialPaidPreAuthDollarIcon;
          break;
        } else if (ticketStatusId === 0 && preAuth && check.unpaidAmount > 0) {
          preAuthImg = currency === '£' ? preAuthPoundIcon : preauthIcon;
          break;
        }
      }
    }
    if (check && check.unpaidAmount === 0 && check.paidAmount > 0) {
      paidImg = paidIcon;
    } else if (check && check.unpaidAmount !== 0 && check.paidAmount > 0) {
      paidImg = partialPaidIcon;
    } else {
      paidImg = unpaidIcon;
    }
    return { paidIcon: paidImg, preAuthIcon: preAuthImg };
  };

  static getCheckSourceIcon = (sourceType, delivery, isMarketOrder, isCatering, isTab) => {
    if (isMarketOrder) {
      return isCatering && delivery ? cateringDeliveryIcon : isCatering ? cateringIcon : delivery ? marketOrderDelivery : marketOrderOnline;
    }
    switch (sourceType) {
      case 0: // POS, DEFAULT
        return (isTab === null || isTab === undefined) ? posIcon : isTab ? tabIcon : tableIcon;
      case 1: //KIOSK
        return kioskIcon;
      case 5: // CURBSIDE
        return curbSideIcon;
      case 6: // ONLINE
        return delivery ? deliveryIcon : onlineIcon;
      case 7: // WALKUP
        return walkupIcon;
      case 8: // TEXTTOPAY
        return textToPayIcon;
      case 9: // SCANTOPAY
        return scanToPayIcon;
      case 10: //Call Center Order
        return callCenterIcon;
      default:
        return '';
    }
  };

  static addPrefixWithZero = (num, size) => {
    let str = String(num);
    while (str.length < (size || 10)) {
      str = '0' + str;
    }
    return str;
  };

  static getSupportNumber = () => '8882650707';

  static updatePOSItems = (check) => {
    const checkItems = {};
    const seats = check && check.seats;
    check.items &&
      check.items.forEach((i) => {
        const itemSeats = i.seats;
        const isTableItem =
          i.seats.some((seat) => seat.tableOrder) || itemSeats.length === 0;
        const seat =
          seats &&
          seats.find((s) => !!itemSeats.find((is) => s.id === is.seatId));
        const seatName = seat?.name ? `(${seat.name})` : '';
        const sectionTag = `${isTableItem
          ? constants.table
          : `${constants.sectionSeat} ${seat?.number || ''} ${seatName}`
          }`;
        const section = {
          name: sectionTag,
          selected: false,
          memberId: seat ? seat.memberId : null,
          disableAgeRestricted: seat?.disableAgeRestricted || false,
        };
        i.section = section;
        if (!checkItems[sectionTag]) {
          checkItems[sectionTag] = [i];
        } else {
          checkItems[sectionTag].push(i);
        }
      });
    return checkItems;
  };

  static updatePendingPOSItems = (items, item) => {
    const checkItems = {};
    const seats = item.seats;
    items.forEach(i => {
      const itemSeats = i.seatIds;
      const isTableItem =
        itemSeats.map(each => FireboardUtils.getSeatsForSeatIds(each, item)).some(seat => seat.tableOrder) ||
        itemSeats.length === 0;
      const seat = seats.find(s => !!itemSeats.find(seatId => s.id === seatId));
      const seatName = seat?.name ? `(${seat.name})` : '';
      const sectionTag = `${isTableItem ? constants.table : `${constants.sectionSeat} ${seat?.number || ''} ${seatName}`
        }`;
      const section = {
        name: sectionTag,
        selected: false,
        memberId: seat?.memberId,
        disableAgeRestricted: seat?.disableAgeRestricted || false,
      };
      i.section = section;
      if (!checkItems[sectionTag]) {
        checkItems[sectionTag] = [i];
      } else {
        checkItems[sectionTag].push(i);
      }
    });
    return checkItems;
  };

  static getSeatsForSeatIds = (seatId, item) => {
    const seats = item.seats;
    const seat = seats && seats.filter(each => each.seatId === seatId);
    return seat;
  };

  static isObjectBlank = obj => {
    return !(obj && Object.keys(obj).length !== 0 && obj.constructor === Object);
  };

  static getLastCodeFromQrCode = qrCode => {
    let code = '';
    if (qrCode) {
      const qrStr = String(qrCode).trim();
      const qr = qrStr.endsWith('/') ? qrStr.slice(0, -1) : qrStr; //remove trailing slash
      const qrArray = qr.split('/');
      code = qrArray[qrArray.length - 1];

      //check for query params
      if (code.includes('?')) {
        const queryParamsArr = code.split('=');
        code = queryParamsArr[queryParamsArr.length - 1];
      }
    }
    return code;
  };

  static getCubbySlotsData = (storeCubby, checks) => {
    const checksMap = new Map();
    checks.forEach(check => {
      const [order0] = check?.orders || [];
      const { storeCubbySlotId } = order0 || {};
      if (storeCubbySlotId)
        checksMap.set(storeCubbySlotId, check);
    });

    const { rowCount, columnCount, slots } = storeCubby || {};
    let slots2DArr = Array.from({ length: rowCount }, () => Array.from({ length: columnCount }, () => null));
    Array.isArray(slots) &&
      slots.length > 0 &&
      slots.forEach(slot => {
        let slotData = {
          ...slot,
          checkData: {},
        };
        const { id: slotId } = slot;
        if (slotId && checksMap.has(slotId)) {
          slotData = {
            ...slot,
            checkData: { ...checksMap.get(slotId) },
          }
        }
        slots2DArr[slot.rowNumber - 1][slot.columnNumber - 1] = slotData;
      });

    return slots2DArr;
  };

  static buildStoreCubbyHashTable = storeCubby => {
    const { slots } = storeCubby || {};
    let mapObj = new Map();
    Array.isArray(slots) &&
      slots.length > 0 &&
      slots.forEach(slot => {
        mapObj.set(slot.id, slot);
      });
    return mapObj;
  };

  static getElapsedTimeInMilliseconds = (dueDate) => {
    if (!dueDate) return 0;
    const currentTime = new Date().getTime();
    let date;
    if (dueDate && dueDate.includes('Z'))
      date = new Date(dueDate);
    else
      date = new Date(dueDate + 'Z');
    const dueTime = new Date(date).getTime();
    return currentTime - dueTime;
  };

  static convertElapsedTimeToDisplayTime = elapsedTime => {
    if (!elapsedTime)
      return "- -";
    const time = Math.abs(elapsedTime);
    const convertedTimeInSeconds = parseInt(time / TimeConstants.SECOND);
    if (convertedTimeInSeconds < 60)
      return `${UTIL.round(convertedTimeInSeconds, 0)}s`;
    const convertedTimeInMinutes = convertedTimeInSeconds / 60;
    if (convertedTimeInMinutes < 120)
      return `${UTIL.round(convertedTimeInMinutes, 0)}m`;
    return "2h+";
  };

  static isViewOnMapOptionVisible = (enableGpsLocation, latitude, longitude, orders) => {
    const [order0] = orders || [];
    const { latitude: orderLat, longitude: orderLng } = order0 || {};
    let enableViewOnMap = false;
    if (enableGpsLocation &&
      (latitude !== null && latitude !== undefined) &&
      (longitude !== null && longitude !== undefined) &&
      (orderLat !== null && orderLat !== undefined) &&
      (orderLng !== null && orderLng !== undefined)) {
      enableViewOnMap = true;
    }
    return enableViewOnMap;
  };

  static pad = (value, size) => {
    let str = String(value);
    let len = size || 10;
    while (len > 0) {
      str = '0' + str;
      len--;
    }
    return str;
  };

  static sortByValue = (a, b) => {
    const value1 = FireboardUtils.pad(a).toLowerCase();
    const value2 = FireboardUtils.pad(b).toLowerCase();
    if (value1 < value2)
      return -1;
    if (value1 > value2)
      return 1;
    return 0;
  };

  static sortByName = (a, b) => {
    const name1 = FireboardUtils.pad(a?.name ? a.name : '').toLowerCase();
    const name2 = FireboardUtils.pad(b?.name ? b.name : '').toLowerCase();
    if (name1 < name2)
      return -1;
    if (name1 > name2)
      return 1;
    return 0;
  };

  static buildSensorsHashTable = sensors => {
    let sensorsMapObj = new Map();
    if (sensors && Array.isArray(sensors) && sensors.length > 0) {
      sensors.forEach(sensor => {
        if (sensor.sensorGroupId) {
          if (sensorsMapObj.has(sensor.sensorGroupId)) {
            //if there is an entry with sensorGroupId - append new sensor to existing sensors array
            sensorsMapObj.set(sensor.sensorGroupId, [...sensorsMapObj.get(sensor.sensorGroupId), sensor]);
          } else {
            //create new sensors array and set key as sensorGroupId and value as sensors array
            sensorsMapObj.set(sensor.sensorGroupId, [sensor]);
          }
        }
      });
    }
    return sensorsMapObj;
  };

  static getTimeIn12HourClock = time => {
    if (!time) return;
    const splitValues = String(time).split(':');
    const hours = +splitValues[0];
    const session = hours >= 12 ? 'PM' : 'AM';
    let hrs = hours > 12 ? hours - 12 : hours;
    hrs = hrs === 0 ? 12 : hrs; // adding condition to handle 12 AM
    hrs = hrs < 10 ? `0${hrs}` : hrs;
    const mins = +splitValues[1] < 10 ? `0${+splitValues[1]}` : +splitValues[1];
    return `${hrs}:${mins} ${session}`;
  };

}
